// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class RTMSResource_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.RTMSResource';
  $t: string = 'SagaSchema.RTMSResource';

  public static GetMembers(): string[] {
    return ['resResourceUid', 'resTypeConst', 'SelectOrder', 'ResourceRank'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return RTMSResource_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public resResourceUid: Guid = GuidTools.Empty;
  public resTypeConst: number = 0;
  public SelectOrder: number = 0;
  public ResourceRank: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.resResourceUid;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
